import { MapPinIcon } from "@/icons/MapPinIcon";
import { CheckCircleIcon } from "@/icons/CheckCircleIcon";
import { ShieldIcon } from "@/icons/ShieldIcon";
import styles from "./MockCheckin.module.css";

export function MockCheckin() {
  return (
    <div className={styles.phone} aria-hidden="true">
      <div className={styles.notch} />
      <div className={styles.screen}>
        <div className={styles.browserBar}>
          <ShieldIcon width={10} height={10} className={styles.browserLock} />
          <span className={styles.browserUrl}>tidyrota.com</span>
        </div>
        <div className={styles.header}>
          <MapPinIcon width={16} height={16} />
          <span className={styles.siteName}>Canary Wharf Tower</span>
        </div>
        <div className={styles.body}>
          <div className={styles.checkmark}>
            <CheckCircleIcon width={48} height={48} />
          </div>
          <p className={styles.confirmText}>Checked In</p>
          <p className={styles.timeText}>09:02 AM</p>
          <span className={styles.gpsTag}>GPS Confirmed</span>
        </div>
        <div className={styles.footer}>
          <div className={styles.shiftInfo}>
            <span className={styles.shiftLabel}>Today&apos;s shift</span>
            <span className={styles.shiftTime}>09:00 – 17:00</span>
          </div>
        </div>
      </div>
    </div>
  );
}
